import { GoogleAdProvider } from '../providers/GoogleAdProvider';
import { AdSlotRegistry } from '../services/AdSlotRegistry';
import { TargetingManager } from '../services/TargetingManager';
import { AdOrchestrator } from '../services/AdOrchestrator';
import type { IAdOrchestrator, IAdProvider, IAdSlotRegistry, ITargetingManager } from '../types/ad-manager.interfaces';

let provider: IAdProvider | undefined;
let registry: IAdSlotRegistry | undefined;
let targeting: ITargetingManager | undefined;
let orchestrator: IAdOrchestrator | undefined;

export interface UseAdManagerReturn {
	provider: IAdProvider;
	registry: IAdSlotRegistry;
	targeting: ITargetingManager;
	orchestrator: IAdOrchestrator;
}

export const useAdManager = (): UseAdManagerReturn => {
	if (!provider) {
		provider = new GoogleAdProvider();
		registry = new AdSlotRegistry();
		targeting = new TargetingManager(provider);
		orchestrator = new AdOrchestrator(provider, registry, targeting);
	}
	return {
		provider,
		registry: registry!,
		targeting: targeting!,
		orchestrator: orchestrator!,
	};
};

/**
 * Reset singletons — **only for tests**.
 */
export const _resetAdManager = (): void => {
	provider = undefined;
	registry = undefined;
	targeting = undefined;
	orchestrator = undefined;
};
